import { Component } from '@angular/core';
import { ListSpecialPaymentsGracePeriodOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/list-special-payments-periods/list-special-payments-gp-wrapepr.component';
import { NotificationService } from '@app/services/notifications.service';

@Component({
  selector: 'app-list-special-payments-grace-period-open',
  templateUrl: './list-special-payments-grace-period-open.component.html',
  styleUrls: ['./list-special-payments-grace-period-open.component.scss'],
})
export class ListSpecialPaymentsGracePeriodOpenComponent extends ListSpecialPaymentsGracePeriodOpenQuoteWrapper {
  constructor(notificationService: NotificationService) {
    super(notificationService);
  }
}
